import React from 'react';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {clearFilter, noNightTransferSelect, stopSelect} from "../../actions/FlightsActions";
import {bindActionCreators} from "redux";
import PriceFormatter from "../../helpers/PriceFormatter";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";
import {initialState} from "../../reducers/filters/StopsFilterReducer";
import {UncontrolledTooltip} from "reactstrap";

class StopsBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.state = {
            noNightTransferChecked: props.urlFilters.noNightTransfer
        };
        this.filter = 'stops';
        this.name = 'Stops';
        this.urlEnabled = props.urlFilters.stops && props.urlFilters.stops !== initialState.stops;
    }

    stopSelect(e) {
        this.props.stopSelect(e.target.value);
    }

    noNightTransferSelect() {
        this.setState({
            noNightTransferChecked: !this.state.noNightTransferChecked,
        });
        this.props.noNightTransferSelect(!this.state.noNightTransferChecked);
    }

    renderList() {
        let filters = [];

        Object.keys(this.props.maxStops).map((stopCount) =>  filters.push(this.renderFilter(parseInt(stopCount, 10), this.props.maxStops[stopCount])));

        return filters;
    }

    renderStopFilterTranslation(stopsCount) {
        let text = `${this.translator.trans('Max')} ${stopsCount} ${this.translator.trans('stops')}`;
        if (stopsCount === 0) {
            text = this.translator.trans('Non stop');
        } else if (stopsCount === 1) {
            text = this.translator.trans('Max one stop');
        }

        return (
            <span>
                <small><span id={`stops-name-${stopsCount}`}>{text}</span></small>
                <UncontrolledTooltip delay={0} fade={false} placement="top" target={`stops-name-${stopsCount}`}>
                    {text}
                </UncontrolledTooltip>
            </span>
        );
    }

    isChecked(count) {
        return parseInt(this.props.stops, 10) === parseInt(count, 10);
    }

    renderFilter(stopsCount, price) {
        return (
            <div key={stopsCount} className="form-check">
                <label className="form-check-label">
                    <input className="form-check-input" type="radio"
                           onChange={this.stopSelect.bind(this)}
                           checked={this.isChecked(stopsCount)}
                           value={stopsCount}/>
                    {this.renderStopFilterTranslation(stopsCount)}
                </label>
            </div>
        );
    }

    render() {
        if (this.props.maxStops === 0) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold mb-2">{this.translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    <div className="form-check mb-2">
                        <label className="form-check-label">
                            <input checked={this.state.noNightTransferChecked}
                                   onChange={this.noNightTransferSelect.bind(this)} className="form-check-input"
                                   type="checkbox" value="1"/>
                            <small>{this.translator.trans('No night transfers')}</small>
                        </label>
                    </div>
                    {this.renderList()}
                    <div className="form-check">
                        <label className="form-check-label">
                            <input className="form-check-input" type="radio"
                                   onChange={this.stopSelect.bind(this)}
                                   checked={this.isChecked(-1)}
                                   value="-1"/>
                            <small>{this.translator.trans('Any stops')}</small>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        stopSelect,
        noNightTransferSelect,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        maxStops: state.StopsFilterReducer.maxStops,
        stops: state.StopsFilterReducer.stops,
        parameters: state.ParametersReducer.parameters,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StopsBlock);



// WEBPACK FOOTER //
// ./src/components/filters/StopsBlock.js